import { useQuery } from "@tanstack/react-query"

import { SupplierResponses } from "@tfg/types/endpoints/supplier"
import { getProductionSitesSchemaType } from "@tfg/types/schemas/supplier"

import { httpClient } from "~/backend/axios.ts"

export const useListSupplierProductionSitesQuery = (
  params: getProductionSitesSchemaType
) => {
  return useQuery({
    queryKey: ["listProductionSites", params],
    queryFn: async () =>
      (
        await httpClient.get<SupplierResponses.ProductionSite[]>(
          `supplier/production-sites`,
          { params }
        )
      ).data,
  })
}
